export default __webpack_public_path__ + "static/media/doku.435e8e73.webm";